var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{attrs:{"gutter":12}},_vm._l((_vm.urls),function(url,index){return _c('el-col',{key:index,staticClass:"camera",attrs:{"span":6}},[_c('iframe',{attrs:{"src":url,"width":"100%","height":"250"}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }